import React from 'react';
import { Button } from 'antd';
import useExport from './useExport';
import { track } from '@utils';
import { DownloadOutlined } from '@ant-design/icons';

function ExportLink({ config, trackEvent }) {
  const { triggerDownload } = useExport({ config });

  const onClick = () => {
    if (trackEvent) {
      track({ event: trackEvent });
    }
    triggerDownload();
  };

  return (
    <Button onClick={onClick} type="text" size="small" icon={<DownloadOutlined />}>
      Export
    </Button>
  );
}

export default ExportLink;
